import axios from "axios";

// Environment variables
const HOSTING_TARGET = process.env.REACT_APP_HOSTING_TARGET;

// Default to DEV
let baseURL = process.env.REACT_APP_BACKEND_URL_DEV ;
let paymentUID = process.env.REACT_APP_PAYMENT_UID_DEV;
let paymentGlobalLib = process.env.REACT_APP_PAYMENT_LIB_DEV;
let paymentBaseURL = process.env.REACT_APP_PAYMENT_BASE_URL_DEV;
let wsURL = process.env.REACT_APP_WS_URL_DEV;

// Conditional override based on HOSTING_TARGET
if (process.env.REACT_APP_HOSTING_TARGET === "picknprizes-v2-players") {
  baseURL = process.env.REACT_APP_BACKEND_URL_DEV;
  paymentUID = process.env.REACT_APP_PAYMENT_UID_DEV;
  paymentGlobalLib = process.env.REACT_APP_PAYMENT_LIB_DEV;
  paymentBaseURL = process.env.REACT_APP_PAYMENT_BASE_URL_DEV;
  wsURL = process.env.REACT_APP_WS_URL_DEV;
} else if (process.env.REACT_APP_HOSTING_TARGET === "picknprizes-v2-players-uat") {
  baseURL = process.env.REACT_APP_BACKEND_URL_UAT;
  paymentUID = process.env.REACT_APP_PAYMENT_UID_UAT;
  paymentGlobalLib = process.env.REACT_APP_PAYMENT_LIB_UAT;
  paymentBaseURL = process.env.REACT_APP_PAYMENT_BASE_URL_UAT;
  wsURL = process.env.REACT_APP_WS_URL_UAT;
} else {
  baseURL = process.env.REACT_APP_BACKEND_URL_PROD;
  paymentUID = process.env.REACT_APP_PAYMENT_UID_PROD;
  paymentGlobalLib = process.env.REACT_APP_PAYMENT_LIB_PROD;
  paymentBaseURL = process.env.REACT_APP_PAYMENT_BASE_URL_PROD;
  wsURL = process.env.REACT_APP_WS_URL_PROD;
}

const axiosClient = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
});

function someFunctionToCalculateSing(data) {
  return data?.checkHeader || null;
}

// Request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    const accessToken = JSON.parse(localStorage.getItem("token"));
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    const checkHeader = someFunctionToCalculateSing(config.data);
    if (checkHeader) {
      config.headers["Sign"] = checkHeader;
      delete config.data.checkHeader;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export { wsURL, baseURL, paymentUID, paymentGlobalLib, paymentBaseURL };
export default axiosClient;